<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.00195 18H16.002C17.105 18 18.002 17.103 18.002 16V2C18.002 0.897 17.105 0 16.002 0H2.00195C0.898953 0 0.00195312 0.897 0.00195312 2V8.001H6.99995V4L13 9L6.99995 14V10.001H0.00195312V16C0.00195312 17.103 0.898953 18 2.00195 18Z" fill="#FB043F" fill-opacity="0.75"/>
</svg>
